<template>
  <el-dialog
    :model-value="modelValue"
    custom-class="el-dialog--custom"
    width="400px"
    top="0"
    :title="title || $t('delete')"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :show-close="true"
    @close="$emit('update:modelValue', false)"
  >
    <div class="text-center py-2">
      {{ message || $t('confirm_delete') }}
    </div>
    <template #footer>
      <div class="flex">
        <div class="flex-1">
          <el-button type="default" class="btn-default-cancel" @click="$emit('update:modelValue', false)">
            {{ $t('barcode_type.cancel') }}
          </el-button>
        </div>
        <div class="flex-1">
          <el-button
            type="default"
            class="bg-red-min text-white focus:text-white"
            :loading="loading"
            @click="$emit('confirm')"
          >
            {{ $t('delete') }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'DeleteConfirmDialog',
  emits: ['update:modelValue', 'confirm'],
})
export default class DeleteConfirmDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly modelValue!: boolean
  @Prop({ type: String, default: '' }) readonly title!: string
  @Prop({ type: String, default: '' }) readonly message!: string
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
}
</script>
